const PHONE_NUMBER = '59178965522';

export const generateWhatsAppLink = (topic) => {
    const text = `Hola!, Quisiera mas información sobre ${topic} por favor. Gracias :)`;
    return `https://wa.me/${PHONE_NUMBER}?text=${encodeURIComponent(text)}`;
}